<template>
  <div class="modal-window large fullheight split active">
    <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">

      <div class="grid-x split">

        <!-- Split col 1 -->
        <div class="cell large-6 flex-column">

          <div class="modal-window-header">
            <div class="modal-window-heading">
              <h3 class="icon-heading">
                <span class="icon"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-task"></use></svg></span>
                <span class="icon-heading-title">
                  <span class="title">Oppgave</span>
                  <span class="subtitle">Objekt #{{objekt.Objektnr}} - ikke solgt</span>
                </span>
              </h3>
            </div>

            <span class="text-tiny opacity-60 task-date">Registrert: {{ task.createdAt | avantidatetime }}</span>

            <fieldset>
              <div class="grid-x grid-padding-x">
                <div class="cell large-6">
                  <label for="task-status">Status</label>

                  <div class="select-container select-dropdown has-popover" :class="{'popover-active': statusPopoverActive}" @click="toggleStatusPopover()">
                    <a class="select-dropdown-trigger" href="javascript:;">
                      <span v-if="status === 'pending'" class="statusicon incomplete active" id="select-dropdown-1"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-warning"></use></svg></span>
                      <span v-if="status === 'in-progress'" class="statusicon in-progress active" id="select-dropdown-2"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-play"></use></svg></span>
                      <span v-if="status === 'on-hold'" class="statusicon on-hold active" id="select-dropdown-3"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-pause"></use></svg></span>
                      <span v-if="status === 'resolved'" class="statusicon success active" id="select-dropdown-4"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg></span>
                    </a>

                    <select id="status" name="status" tabindex="-1">
                      <option value="pending" :selected="status === 'pending'">Ubehandlet</option>
                      <option value="in-progress" :selected="status === 'in-progress'">Under behandling</option>
                      <option value="on-hold" :selected="status === 'on-hold'">På vent</option>
                      <option value="resolved" :selected="status === 'resolved'">Ferdigbehandlet</option>
                    </select>

                    <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>

                    <span class="popover select-dropdown-popover align-x-right align-y-bottom medium">
                      <ul>
                        <ul>
                          <li :class="{'active': status === 'pending'}"><a href="javascript:;" @click="setStatus('pending')"><span class="statusicon incomplete"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-warning"></use></svg></span> <span>Ubehandlet</span></a></li>
                          <li :class="{'active': status === 'in-progress'}"><a href="javascript:;" @click="setStatus('in-progress')"><span class="statusicon in-progress"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-play"></use></svg></span> <span>Under behandling</span></a></li>
                          <li :class="{'active': status === 'on-hold'}"><a href="javascript:;" @click="setStatus('on-hold')"><span class="statusicon on-hold"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-pause"></use></svg></span> <span>På vent</span></a></li>
                          <li :class="{'active': status === 'resolved'}"><a hhref="javascript:;" @click="setStatus('resolved')"><span class="statusicon success"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-success"></use></svg></span> <span>Ferdigbehandlet</span></a></li>
                        </ul>
                      </ul>
                    </span>
                  </div>
                </div>

                <div class="cell large-6">
                  <label for="task-owner">Ansvarlig</label>
                  <div class="select-container has-popover disabled">
                    <a class="button-select" href="javascript:;">
                      <span class="title"><span>{{task.bruker.full_name}}</span></span>
                      <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
                    </a>
                  </div>
                </div>
              </div>
            </fieldset>

            <div class="panel info no-margin">
              <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-info"></use></svg></span>
              {{task.info}}
            </div>

            <div class="tabs" id="task-modal-tabs">
              <ul>
                <li :class="{'active': tab === 'details'}"><a href="javascript:;" @click="setTab('details')">Detaljer</a></li>
                <li :class="{'active': tab === 'comments'}"><a href="javascript:;"  @click="setTab('comments')">Objektnotater ({{comments.total || 0}})</a></li>
              </ul>
            </div>
          </div>

          <div class="task-modal-tab-container" :class="{'hidden': tab !== 'details'}">
            <!-- Details -->
            <div class="modal-window-body small-padding gray">
              <div class="grid-x grid-padding-x grid-padding-tiny">
                <div class="cell large-6">
                  <div class="card auto-height no-margin">
                    <h3 class="icon-heading tiny">
                      <span class="icon transparent"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-user"></use></svg></span>
                      <span class="icon-heading-title">
                        <span class="title"><a :href="'/kunde/' + kunde.Kundenr" target="_blank">Selger #{{kunde.Kundenr}}</a></span>
                      </span>
                    </h3>

                    <dl>
                      <dt>Navn</dt>
                      <dd v-if="kunde.Bedrift && kunde.FirmaNavn">
                        <span v-if="kunde.full_name">{{kunde.full_name}}</span>
                      </dd>
                      <dd v-else>{{kunde.full_name}}</dd>

                      <dt>E-post</dt>
                      <dd v-if="kunde.Email"><a :href="'mailto:' + kunde.Email">{{kunde.Email}}</a></dd>
                      <dd v-else>-</dd>

                      <dt>Telefon</dt>
                      <dd>{{kunde.full_phone || '-'}}</dd>

                      <dt>Leveringsadresse</dt>
                      <dd v-if="kunde.full_address_lev">{{kunde.full_address_lev || '-'}}</dd>

                      <dt>Fakturaadresse</dt>
                      <dd v-if="kunde.full_address_fak">{{kunde.full_address_fak || '-'}}</dd>
                    </dl>
                  </div>
                </div>

                <div class="cell large-6">
                  <div class="card auto-height no-margin">
                    <h3 class="icon-heading tiny">
                      <span class="icon transparent"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-object"></use></svg></span>
                      <span class="icon-heading-title">
                        <a :href="'/kunde/' + kunde.Kundenr + '?kontrakt=' + objekt.Kontraktnr + '&objekt=' + objekt.Objektid" target="_blank"><span class="title">Objekt #{{objekt.Objektnr}}</span></a>
                      </span>
                    </h3>

                    <dl>
                      <dt>Tittel</dt>
                      <dd class="has-tooltip">{{task.ObjektTitle}}</dd>

                      <dt>Avdeling</dt>
                      <dd>{{objekt.avdeling.Beskrivelse}}</dd>

                      <dt>Vurdering</dt>
                      <dd v-if="objekt.Vurderingspris1>0 && objekt.Vurderingspris2>0">
                        {{objekt.Vurderingspris2 | thousands}} - {{objekt.Vurderingspris1 | thousands}}
                      </dd>
                      <dd v-else-if="objekt.Vurderingspris1>0">
                        {{objekt.Vurderingspris1 | thousands}}
                      </dd>
                      <dd v-else-if="objekt.Vurderingspris2>0">
                        {{objekt.Vurderingspris2 | thousands}}
                      </dd>
                      <dd v-else>
                        -
                      </dd>

                      <dt>Minstepris</dt>
                      <dd>{{objekt.Minstepris | thousands}}</dd>

                      <dt>Antall ganger i auksjon</dt>
                      <dd>{{task.json && task.json.auction_count ? task.json.auction_count : '-'}}</dd>
                    </dl>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="task-modal-tab-container" :class="{'hidden': tab !== 'comments'}">
            <div class="modal-window-body gray no-padding-bottom">
              <div class="messages-container">
                <div class="message" v-for="comment in comments.items" v-bind:key="comment.id">
                  <div class="message-avatar" :class="strToAvatarClass(comment.bruker.initials || '-')" v-if="comment.bruker">
                    <span class="avatar name right">{{comment.bruker.initials || '-'}} <span class="name">{{comment.bruker.full_name || '-'}}</span></span>
                  </div>
                  <span class="avatar name right" :class="strToAvatarClass('-')" v-else>
                    {{comment.Registrert_av || '-'}}
                    <span class="name">{{comment.Registrert_av || '-'}}</span>
                  </span>
                  <div class="message-content">
                    <p v-html="$options.filters.nlbr(comment.Notat)">{{comment.Notat | nlbr}}</p>
                    <div class="message-timestamp"><time>{{comment.Registrert_tid | avantidatenice}}</time></div>

                    <template v-if="comment.bruker && comment.bruker.Brukerid === $store.getters.getUser.Brukerid">
                      <a v-if="comment.deleting" href="javascript:;" class="message-delete">
                        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg>
                        Sletter
                      </a>
                      <a v-else @click="deleteComment(comment)" href="javascript:;" class="message-delete">
                        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-delete"></use></svg>
                        Slett
                      </a>
                    </template>
                  </div>
                </div>

                <div class="message" v-if="comments.items.length > 0">
                  <div style="width: 100%; text-align: center; margin-top: 10px" v-if="comments.pages > 1 && comments.params.page < comments.pages">
                    <button href="javascript:;" @click="loadMoreComments()" class="button secondary action glyph" v-if="!comments.loading">
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                      <span>Last fler</span>
                    </button>
                    <button href="javascript:;" class="button secondary action glyph loading" v-else>
                      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-add"></use></svg>
                      <span>Laster fler <span class="loader-spinner"></span></span>
                    </button>
                  </div>
                  <div style="width: 100%; text-align: center; margin-top: 10px; font-size: 0.8em" v-else-if="!comments.loading">
                    Alt har blitt lastet inn
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-window-footer no-padding">
              <form @submit.prevent="saveComment" style="width: 100%">
                <div class="grid-x">
                  <div class="cell small-12">
                    <div class="input-container" :class="{'form-error': errors.has('Notat')}">
                      <textarea
                        autocomplete="off"
                        placeholder="Legg til objektnotat…"
                        v-model="newComment"
                        v-validate="'required|max:2000'"
                        name="Notat"
                        rows="3"
                        :disabled="comments.loading || comments.saving"
                        :class="{ 'error': errors.has('Notat') }"></textarea>
                      <span class="form-error-label" v-if="errors.has('Notat')">
                        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                        {{errors.first('Notat')}}
                      </span>
                    </div>
                  </div>

                  <div class="cell small-12">
                    <div class="grid-x">
                      <div class="cell auto"></div>

                      <div class="cell shrink">
                        <a v-if="comments.loading" href="javascript:;" class="button primary disabled"><span class="button-title">Lagre objektnotat</span></a>
                        <a v-else-if="comments.saving" href="javascript:;" class="button primary initiate-loading loading"><span class="button-title">Lagre objektnotat</span> <span class="loader-spinner"></span></a>
                        <a v-else @click="saveComment()" href="javascript:;" class="button primary initiate-loading"><span class="button-title">Lagre objektnotat</span></a>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- // Split col 1 -->

        <!-- // Split col 2 -->
        <div class="cell large-6 flex-column">
          <div class="modal-window-header">
            <div class="modal-window-heading">
              <h3 class="icon-heading">
                <span class="icon"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-email"></use></svg></span>
                <span class="icon-heading-title">
                  <span class="title">Send e-post</span>
                  <span class="subtitle">E-posten lagres i objekt historikk</span>
                </span>
              </h3>
            </div>
          </div>

          <div class="modal-window-body">
            <form @submit.prevent="handleEmailSubmit">
              <fieldset>
                <div class="grid-x grid-padding-x">
                  <TheTextInput v-model.trim="emailData.from_name" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Avsender'" :placeholder="'Avsender navn…'" name="email_from_name" required v-validate="nameRule"/>
                  <TheEmailInput v-model.trim="emailData.from_mail" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Avsender e-post'" :placeholder="'Avsender e-post…'" name="email_from_mail" required v-validate="mailRule"/>

                  <TheTextInput v-model.trim="emailData.to_name" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Mottaker'" :placeholder="'Mottaker navn…'" name="email_to_name" required v-validate="nameRule"/>
                  <TheEmailInput v-model.trim="emailData.to_mail" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Mottaker e-post'" :placeholder="'Mottaker e-post…'" name="email_to_mail" required v-validate="mailRule"/>

                  <TheTextInput v-model.trim="emailData.subject" containerClassName="cell medium-12" :label="'Emne'" :placeholder="'Emne…'" name="email_subject" required v-validate="subjectRule"/>
                  <TheTextArea v-model="emailData.content" containerClassName="cell medium-12" :label="'Tekst'" :placeholder="'E-post tekst…'" name="email_content"  :rows="6" required v-validate="contentRule"/>

                  <div class="cell auto"></div>
                  <div class="cell shrink">
                    <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitEmailButtonClick()" class="button primary submit large">Send e-post</a>
                    <a v-else-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Send e-post...<span class="loader-spinner"></span></a>
                    <a v-else href="javascript:;" class="button primary submit large" disabled>Send e-post</a>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </overlay-scrollbars>
  </div>
</template>

<script>
import OppgaveService from '@/services/OppgaveService'
import ObjektService from '@/services/ObjektService'
import bus from '@/plugins/event-bus'

export default {
  name: 'DashboardObjektUsolgteModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      item: null,
      objekt: null,
      kunde: null,
      loading: false,
      emailData: {},
      tab: 'details',
      newComment: null,
      comments: {
        items: [],
        total: 0,
        pages: 1,
        loading: false,
        saving: false,
        deleting: false,
        params: {
          limit: 25,
          page: 1
        }
      },
      status: null,
      statusList: [
        { key: 'pending', val: 'Ubehandlet', cls: 'incomplete' },
        { key: 'in-progress', val: 'Under behandling', cls: 'in-progress' },
        { key: 'on-hold', val: 'På vent', cls: 'on-hold' },
        { key: 'resolved', val: 'Ferdigbehandlet', cls: 'success' }
      ],
      statusPopoverActive: false,
      showForm: 'email'
    }
  },
  created () {
    const vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.statusPopoverActive = false
      }
    })

    this.setFormLoading(false)
    this.setup()
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  computed: {
    nameRule: function () {
      return 'required|max:100'
    },
    mailRule: function () {
      return 'required|email'
    },
    subjectRule: function () {
      return 'required|max:50'
    },
    contentRule: function () {
      return 'required'
    },
    statusText: function () {
      const found = this.statusList.find(x => x.key === this.item.status)

      return found ? found.val : '-'
    }
  },
  methods: {
    setup: function () {
      // Task/item / Objekt / Kunde
      this.item = this._.cloneDeep(this.task)
      this.objekt = this._.cloneDeep(this.task.objekt)
      this.kunde = this._.cloneDeep(this.task.objekt.kontrakt.kunde)

      this.status = this.item.status

      // Set email data
      let tempData = {}

      tempData.from_mail = this.task.bruker.Email || (this.$store.getters.getUser.Email || '')
      tempData.from_name = this.task.bruker.full_name || (this.$store.getters.getUser.full_name || '')

      tempData.to_mail = this.kunde.Email || ''
      tempData.to_name = this.kunde.full_name || ''

      tempData.subject = 'Blomqvist usolgt objekt #' + this.objekt.Objektnr
      tempData.content = ''

      this.emailData = Object.assign({}, tempData)

      this.loadComments()
    },
    loadComments: function (reload = false) {
      this.comments.loading = true

      ObjektService.getObjektNotater(this.objekt.Objektid, this.comments.params)
        .then((response) => {
          if (!reload) {
            this.comments.items = response.data
          } else {
            let newItems = response.data || []

            newItems.forEach(i => {
              this.comments.items.push(i)
            })
          }
          this.comments.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          this.comments.total = response.headers['x-paging-count'] ? parseInt(response.headers['x-paging-count']) : 0
        })
        .catch((error) => {
          console.log('Error', error)
        })
        .then(() => {
          this.comments.loading = false
        })
    },
    loadMoreComments: function () {
      this.comments.params.page += 1

      this.loadComments(true)
    },
    saveComment: function () {
      if (this.comments.saving) {
        return
      }

      this.comments.saving = true

      this.$validator.validate('Notat')
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.comments.saving = false
            this.$helpers.showErrorAlert('Kunne ikke lagre objektnotat', 'Vennligst korriger feil i skjemaet')
          } else {
            const post = {
              Objektid: this.objekt.Objektid,
              Notat: this.newComment
            }

            const prevValue = this.newComment

            ObjektService.addObjektNotat(post.Objektid, post)
              .then((response) => {
                this.comments.items.unshift(response.data)
                this.comments.total += 1

                this.newComment = ''
              })
              .catch((error) => {
                console.log('Error', error)
                this.newComment = prevValue
                this.$helpers.showErrorAlert('Kunne ikke lagre objektnotat', 'Vennligst prøv igjen')
              })
              .then(() => {
                this.comments.saving = false
              })
          }
        })
    },
    deleteComment: function (item) {
      if (this.comments.deleting || this.comments.saving) {
        return
      }

      this.comments.deleting = true

      let post = {
        Objektid: this.objekt.Objektid,
        id: item.id
      }

      ObjektService.delObjektNotat(post.Objektid, post.id)
        .then((response) => {
          if (this.comments.items) {
            const index = this.comments.items.findIndex(x => x.id === item.id)

            this.comments.items.splice(index, 1)
            this.comments.total -= 1
          }
        })
        .catch((error) => {
          console.log('Error', error)
          this.$helpers.showErrorAlert('Kunne ikke slette objektnotat', 'Vennligst prøv igjen')
        })
        .then(() => {
          this.comments.deleting = false
        })
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    submitEmailButtonClick: function () {
      this.handleEmailSubmit()
    },
    handleEmailSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      if (this.emailData.content) {
        this.emailData.content = this.emailData.content.trim()
      }

      let validationPromises = []
      const validateInputs = [
        'email_from_name',
        'email_from_mail',
        'email_to_name',
        'email_to_mail',
        'email_subject',
        'email_content'
      ]

      validateInputs.forEach(input => {
        validationPromises.push(this.$validator.validate(input))
      })

      Promise.all(validationPromises)
        .then(data => {
          // Find false promises
          let failed = data.filter(x => x === false)

          if (failed.length > 0) {
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
            this.setFormProcessing(false)
          } else {
            OppgaveService.sendUnsoldObjectEmail(this.task.id, this.emailData)
              .then((response) => {
                this.status = response.data.task.status
                this.$set(this.item, 'status', response.data.task.status)
                bus.$emit('oppgave-changed', this.item)

                if (response.data.comment) {
                  this.comments.items.unshift(response.data.comment)
                  this.comments.total += 1
                }

                this.$helpers.showSuccessAlert('E-posten har blitt sendt til kunde')
              })
              .catch((error) => {
                console.log('Error', error)
                this.$helpers.showErrorAlert('Feil', 'Kunne ikke sende e-post til kunde')
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    setTab: function (tab) {
      this.tab = tab
    },
    setStatus: function (itemId) {
      if (!itemId) {
        return
      }

      this.status = itemId

      OppgaveService.save(this.item.id, {status: this.status})
        .then((response) => {
          this.status = response.data.status
          this.$set(this.item, 'status', response.data.status)
          bus.$emit('oppgave-changed', this.item)
        })
        .catch((error) => {
          console.log('Error', error)
          // Take back status
          this.status = this.item.status
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke endre status')
        })
        .then(() => {
          console.log('Done')
        })
    },
    toggleStatusPopover: function () {
      this.statusPopoverActive = !this.statusPopoverActive
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/ModalOppgave.vue